import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page from "../Page";
import { SessionKeys } from "../../utils/AppUtils";
import {
  getAllEventsBroker,
  getAllEventsBrokerClear,
} from "../../redux/events/actions";
import _ from "lodash";
import { t } from "i18next";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThLarge, faList } from "@fortawesome/free-solid-svg-icons";
import ShimmerNotification from "../Layouts/ShimmerNotification";
import ManageGroupWorkshopDetailComponent from "./ManageGroupWorkshopDetailComponent";
import Loader from "../Loader/Loader";
import NotFoundComponent from "../NewDesign/NotFound/NotFoundComponent";
import CONFIG from "../../utils/config";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import { useNavigate } from "react-router-dom";

function ManageGroupWorkshop() {

  const dispatch = useDispatch();
  const observer = useRef();
  const navigate = useNavigate();

  const [workshops, setWorkshops] = useState([]);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [hasNoMore, setHasNoMore] = useState(true);
  const [search, setSearch] = useState("");
  const [viewMode, setViewMode] = useState("grid");
  const [isLoading, setIsLoading] = useState(false);
  const [productCardArr, setProductCardArr] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  const [workshopCount, setWorkshopCount] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [apiListing, setApiListing] = useState([]);
  const [pageSize, setPageSize] = useState(14);

  // const pageSize = 6;

  const allBrokerEventList = useSelector(
    (state) => state.events.allEventsBroker
  );

  const apiCall = (pageNum) => {
    setIsLoading(true);
    dispatch(
      getAllEventsBroker({
        module: "eventListBroker",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "Workshop",
          search: search,
          provider_id: "",
          sort_by: "",
          filter: "",
          page_size: pageSize,
          page: pageNum,
          isAll: false,
        },
      })
    );
  };

  const resetAll = () => {
    setProductCardArr(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsFetching(false);
    setHasNoMore(true);
    setTotalRecords(0);
    setCurrentPage(0);
    setApiListing([]);
    setPageNum(1);
  }

  useEffect(() => {
    resetAll();
    apiCall(1);
    return () => {
      dispatch(getAllEventsBrokerClear());
    };
  }, [dispatch, pageNum, search]);

  useEffect(() => {
    console.log("start3");
    apiCall(pageNum);
  }, [pageNum]);

  useEffect(() => {
    if (!_.isEmpty(allBrokerEventList)) {
      if (allBrokerEventList.status === "success") {
        const fetchedWorkshops = allBrokerEventList?.payload?.payload?.records;
        let total_records = allBrokerEventList?.payload?.payload?.total_records; 
        setTotalRecords(total_records);
        // setWorkshops(fetchedWorkshops);
        // setTotalRecords(allBrokerEventList?.payload?.payload?.total_records);

        // if (fetchedWorkshops?.length > 0) {
        //   setSelectedWorkshop(fetchedWorkshops[0]);
        // }
        if (!_.isEmpty(fetchedWorkshops)) {
          let productArr = []
          for (let workshop of fetchedWorkshops) {
            productArr.push({
              id: workshop?.list_id,
              ecom_id: workshop?.list_id,
              is_like: false,
              is_bookmark: false,
              is_wishlist: false,
              dbId: workshop?.list_id,
              productType: "workshop",
              productOrigin: workshop.source,
              title: workshop.title,
              logoURL: "",
              bannerURL: workshop.thumbnail,
              tagsArray: [],
              description: workshop.description,
              btnTitle: 'Edit',
              progress: 0,
              isLoggedIn: true,
              btnAction: () => {
                navigate(`/learn/workshop/edit?e=${btoa(JSON.stringify({ "workshopId": workshop.event_id }))}`)
              },
              descAction: () => { },
              bannerAction: () => {
                navigate(`/learn/workshop/edit?e=${btoa(JSON.stringify({ "workshopId": workshop.event_id }))}`)
              },
              footerLineComp: "",
              showHeader: true,
              showProviderIcon: true,
              showLikeMenu: false,
              showBody: false,
              showFooter: true,
              showProgress: false,
              cardClassName: "",
              rightBtnIcon: "/images/arrow-right.svg",
              leftBtnIcon: "",
              updatedAt: "",
              priceInfo: {},
              isBundle: false,
              bundles: [],
            })
          }
          console.log('productArr', productArr)
          let newProdArr = productArr;
          if (pageNum > 1) {
            newProdArr = [...apiListing, ...productArr];
            console.log('productArrnew', newProdArr);
            setProductCardArr(newProdArr);
            setApiListing(newProdArr);
            setIsFetching(false);
          } else {
            console.log('productArrnewpage', newProdArr);
            setProductCardArr(productArr);
            setApiListing(productArr);
          }

          // setCourseCount(newProdArr.length);
          console.log("recordsLength: ", total_records);
          if (total_records === newProdArr.length) {
            setIsFetching(false);
            setHasNoMore(true);
          } else {
            setHasNoMore(false);
          }
        } else {
          setProductCardArr([])
        }
        setIsLoading(false);
      } else {
        setWorkshops([]);
        setIsLoading(false);
        setProductCardArr([])
      }
    }
  }, [allBrokerEventList]);

  const totalPages = Math.ceil(totalRecords / pageSize);

  const paginateCB = useCallback(
    (node) => {
      if (isFetching) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        console.log("pageNumhasNoMore ", isFetching, entries[0].isIntersecting);
        if (entries[0].isIntersecting && !hasNoMore) {
          setIsFetching(true);
          setHasNoMore(true);
          // console.log('End of file', totalRecords, lpListing.length, pageNum, isLoading, isFetching)
          setPageNum((pageNum) => pageNum + 1); //pageNum => pageNum + 1
          setProductCardArr([...productCardArr, ...CONFIG.INITIAL_PRODUCT_CARD_DATA]);
        }
      });

      if (node) observer.current.observe(node);
      console.log(node);
    },
    [hasNoMore]
  );

  return (
    <>
      <Loader start={isLoading} />
      <section className="bannersection manage-worksop">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col col-xl-12 col-lg-10 col-md-12">
              <div className="contsection">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mentor-title mb-0">{t("manageWorkshop")}</h3>
                  <a href="/create-group-workshop">
                    <button className="btn-primary active-page d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M11 10.9996V2.00001L13 2V10.9996L22.0001 10.9994L22.0002 12.9994L13 12.9996L13.0001 21.9995H11.0001V12.9996L2.00004 12.9998L2 10.9998L11 10.9996Z"
                          fill="white"
                        ></path>
                      </svg>
                      {t("createGroupWorkshop")}
                    </button>
                  </a>
                </div>
                <section className="cal-event-sec">
                  <div className="container">
                    <div
                      id={`${!_.isEmpty(workshops) ? "idDetailScreen" : ""}`}
                      className="row mt-4"
                    >
                      <div className="col-md-12 col-xl-12 mb-4">
                        <div className="d-sm-flex justify-content-between align-items-center mb-3 flex-md-wrap">
                          <div className="search-section-listing">
                            <form className="confirm-row m-0">
                              <input
                                type="search"
                                placeholder={t("Search")}
                                className="form-control"
                                onChange={(e) => {
                                  if (e.target.value.length >= 3) {
                                    setSearch(e.target.value);
                                  } else if (e.target.value.length === 0) {
                                    setSearch(e.target.value);
                                  }
                                }}
                              />
                              <button
                                type="button"
                                className="confirm-btn cursor-not-allowed"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                                    fill="black"
                                  ></path>
                                </svg>
                                Search
                              </button>
                            </form>
                          </div>

                          {!_.isEmpty(workshops) && workshops?.length > 6 && (
                            <div className="d-flex cal_iconLR cal-btn-black">
                              <button
                                onClick={() =>
                                  setCurrentPage((prev) =>
                                    Math.max(1, prev - 1)
                                  )
                                }
                                disabled={currentPage === 1}
                                className="button-reset cursor-pointer"
                              >
                                <svg
                                  width="28"
                                  height="28"
                                  viewBox="0 0 28 28"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                    cx="14"
                                    cy="14"
                                    r="13.5"
                                    stroke="#415385"
                                  ></circle>
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M15.1918 18.3752C14.9625 18.3752 14.7342 18.286 14.5627 18.1083L11.1825 14.6083C10.8518 14.2645 10.8562 13.7193 11.1939 13.3816L14.6939 9.88159C15.0352 9.53947 15.589 9.53947 15.9312 9.88159C16.2724 10.2237 16.2724 10.7767 15.9312 11.1188L13.0393 14.0107L15.8209 16.8921C16.1569 17.2403 16.1473 17.7942 15.7999 18.1293C15.6293 18.2938 15.4105 18.3752 15.1918 18.3752Z"
                                    fill="#415385"
                                  ></path>
                                </svg>
                              </button>

                              <div className="page-count mt-0">
                                {t("page")} {currentPage} {t("of")} {totalPages}
                              </div>

                              <button
                                onClick={() =>
                                  setCurrentPage((prev) =>
                                    Math.min(totalPages, prev + 1)
                                  )
                                }
                                disabled={currentPage >= totalPages}
                                className="button-reset cursor-pointer"
                              >
                                <svg
                                  width="28"
                                  height="28"
                                  viewBox="0 0 28 28"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                    cx="14"
                                    cy="14"
                                    r="13.5"
                                    transform="rotate(180 14 14)"
                                    stroke="#415385"
                                  ></circle>
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12.8082 9.62478C13.0375 9.62478 13.2658 9.71403 13.4373 9.89166L16.8175 13.3917C17.1482 13.7355 17.1438 14.2807 16.8061 14.6184L13.3061 18.1184C12.9648 18.4605 12.411 18.4605 12.0688 18.1184C11.7276 17.7763 11.7276 17.2233 12.0688 16.8812L14.9607 13.9893L12.1791 11.1079C11.8431 10.7597 11.8527 10.2058 12.2001 9.87066C12.3707 9.70616 12.5895 9.62478 12.8082 9.62478Z"
                                    fill="#415385"
                                  ></path>
                                </svg>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                      <>
                          <div className="row coursecard-row videosection-cont">
                            {productCardArr.length === 0 ? (
                              <>
                                <NotFoundComponent showMsg={true} />
                              </>
                            ) : (
                              //  : <ErrorSection />
                              productCardArr.map((p, i) => {
                                return (
                                  <ProductCardComponent
                                    {...p}
                                    key={`ws-${i + 1}`}
                                    lastKey={productCardArr.length === i + 1}
                                    refInfo={paginateCB}
                                  />
                                );
                              })
                            )}
                          </div>
                        </>
                      { false &&
                      (!_.isEmpty(workshops) ? (
                        <>
                          <div className="col-md-12 col-xl-6">
                            <div className="lef-cal-event-tab">
                              <div className="tab-box-events">
                                <div className="evnts-info-box">
                                  <div className="idSessionList">
                                    <div className="events-body">
                                      <>
                                        {workshops?.length > 0 &&
                                          workshops.map((item, i) => (
                                            <>
                                              <div
                                                onClick={() =>
                                                  setSelectedWorkshop(item)
                                                }
                                                className={`events-section ${
                                                  selectedWorkshop === item
                                                    ? "active"
                                                    : ""
                                                }`}
                                              >
                                                {/* <div className="date-box">
                                                                <div className="text-frame"><span
                                                                        className="number-2">12</span><span
                                                                        className="month-oct">Feb</span></div>
                                                            </div> */}
                                                <div className="events-title-box">
                                                  <div className="events-tilte">
                                                    {item?.title}{" "}
                                                  </div>
                                                  {/* <div className="date-box-events">Wed, 7:00 PM (AST) | Online
                                                                </div> */}
                                                </div>
                                                <div className="events-img">
                                                  {" "}
                                                  <img
                                                    src={
                                                      item?.thumbnail ||
                                                      "/images/event-image.png"
                                                    }
                                                    className="img-fluid"
                                                    alt="Workshop"
                                                  />
                                                </div>
                                              </div>
                                            </>
                                          ))}
                                      </>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {selectedWorkshop && (
                            <ManageGroupWorkshopDetailComponent
                              workshop={selectedWorkshop}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          <NotFoundComponent
                            showMsg={true}
                            msgLine={t("noWorkshopsAvailable")}
                          />
                        </>
                      ))}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
      {false && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="search-filter position-relative">
            <input
              type="search"
              placeholder={t("Search")}
              className="form-control"
              onChange={(e) => {
                if (e.target.value.length >= 3) {
                  setSearch(e.target.value);
                } else if (e.target.value.length === 0) {
                  setSearch(e.target.value);
                }
              }}
            />
          </div>
          {/* <div>
          <button
            className={`btn ${viewMode === "grid" ? "btn-primary" : "btn-outline-primary"} me-2`}
            onClick={() => setViewMode("grid")}
          >
            <FontAwesomeIcon icon={faThLarge} /> Grid View
          </button>
          <button
            className={`btn ${viewMode === "list" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setViewMode("list")}
          >
            <FontAwesomeIcon icon={faList} /> List View
          </button>
        </div> */}
        </div>
      )}

      {false && (
        <div className="row">
          {/* Grid/List View */}
          <div className="col-md-8">
            {viewMode === "grid" ? (
              <div className="row">
                {workshops.length > 0 ? (
                  workshops.map((item, i) => (
                    <div
                      className={`col-md-4 mb-3 ${selectedWorkshop?.list_id === item.list_id
                        ? "border border-primary"
                        : ""
                        }`}
                      key={i}
                      onClick={() => setSelectedWorkshop(item)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="events-section p-3 border rounded">
                        <div className="events-title-box">
                          <div className="events-title">{item?.title}</div>
                        </div>
                        {/* <div className="date-box">
                        <span className="number-2">{moment(item?.start).format("DD")}</span>
                        <span className="month-oct">{moment(item?.start).format("MMM")}</span>
                      </div> */}
                        <div className="events-img">
                          <img
                            src={item?.thumbnail || "/images/event-image.png"}
                            className="img-fluid"
                            alt="Workshop"
                          />
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center w-100">
                    No workshops available.
                  </div>
                )}
              </div>
            ) : (
              <table className="table mb-0 office_list table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th className="cursor-pointer is-sort">Workshop Name</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {workshops.length > 0 ? (
                    workshops.map((workshop, index) => (
                      <tr
                        key={workshop.list_id}
                        className={
                          selectedWorkshop?.list_id === workshop.list_id
                            ? "table-primary"
                            : ""
                        }
                        onClick={() => setSelectedWorkshop(workshop)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>{workshop.title}</td>
                        <td>/</td>
                        <td>{new Date(workshop.update_at).toLocaleString()}</td>
                        <td>
                          <button className="btn btn-primary"></button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No workshops available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Workshop Detail Component */}
          {/* <div className="col-md-4">
          {selectedWorkshop && (
            <ManageGroupWorkshopDetailComponent workshop={selectedWorkshop} />
          )}
        </div> */}
        </div>
      )}

      {/* Pagination Controls */}
      {false && (
        <div className="d-flex justify-content-between mt-3">
          <button
            className="btn btn-secondary"
            onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="btn btn-secondary"
            onClick={() =>
              setCurrentPage((prev) => Math.min(totalPages, prev + 1))
            }
            disabled={currentPage >= totalPages}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
}

export default ManageGroupWorkshop;
